import Swal from 'sweetalert2';
import { Modal } from 'bootstrap';

export default class ScheduleEntry {
    #element;

    constructor(element) {
        this.#element = element;

        this.#bindEvents();
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new ScheduleEntry(element));
    }

    #bindEvents() {
        this.#element.addEventListener('click', this.#loadModal);
    }

    #loadModal = async () => {
        window.
            HttpClient
            .get(this.#element.dataset.source + '?day=' + this.#element.dataset.day)
            .then(this.#showModal)
            .catch(this.#unableToLoad);
    };

    #showModal(response) {
        let modalContainer = document.querySelector('#modal-container');
        modalContainer.innerHTML = response.data;

        let modal = document.querySelector('#modal-container > .modal');

        let modalHandler = new Modal(modal);
        modalHandler.show();
    }

    #unableToLoad() {
        Swal.fire({
            icon: 'error',
            title: 'Oeps...',
            text: 'Kan de activiteit niet ophalen!',
        });
    }
}
